export default "__VITE_ASSET__BaSO2d7t__"